import {
  isValidEmail,
  generateLevels,
  transformFields
} from "./utils";
import {
  approvalModalOptions,
  authenticateType,
  dateFilter,
  dateRanges,
  fieldsArray,
  filterIsActive,
  isActivetrigger,
  isActiveUser,
  levels,
  notificationsApprovals,
  notificationsType,
  notificationtIsActive,
  roles,
  rowStyle,
  sortBy,
  sortIsActive,
  tableIsActive,
  triggerActions,
  triggerApprovals,
  userPermission,
  foreignDesignations
} from "./constant";

export {
  isValidEmail,
  generateLevels,
  transformFields
};

type NotificationType = {
  level: string;
  approval: string;
  isActive: boolean;
};


export const generateApprovalsArray = (
  setFieldValue: any,
  values: any,
  numberOfLevels: any
) => {
  let filteredApprovals = values.approvals.filter(
    (item: any) => parseInt(item.level.value.split("-")[1]) <= numberOfLevels
  );

  for (let i = filteredApprovals.length + 1; i <= numberOfLevels; i++) {
    filteredApprovals.push({
      username: "",
      role: roles[1],
      isActive: isActiveUser[0],
      level: {
        label: `Level ${i}`,
        value: `level-${i}`,
      },
      canUpload: isActiveUser[0],
      selectMode: "select-async",
      addNew: 1,
    });
  }

  let filteredAdmins = values.approvals.filter(
    (item: any) => item.level.value === "admin"
  );

  filteredAdmins.forEach((admin: any) => {
    filteredApprovals.unshift(admin);
  });

  setFieldValue("approvals", filteredApprovals);
};

export const transformResponse = (values: any) => {
  const transformedDateFilter = {
    ...values.dateFilter,
    showFilter: values?.dateFilter?.showFilter,
    range: values?.dateFilter?.range?.value || values?.dateFilter?.range,
    rangeActive: values?.dateFilter?.rangeActive,
    filterKey: values?.dateFilter?.filterKey?.value || values?.dateFilter?.filterKey,
    rangeFilter: values?.dateFilter?.rangeFilter,
  };

  const transformedFileViewer = {
    ...values.fileViewer,
    isFile: values?.fileViewer?.isFile,
    isTable: values?.fileViewer?.isTable,
    isCurebay: values?.fileViewer?.isCurebay,
    editable: values?.fileViewer?.editable,
    show: values?.fileViewer?.show,
    tableFile: values?.fileViewer?.tableFile,
    showApprHistory: values?.fileViewer?.showApprHistory,
    approvalModalOption: values?.fileViewer?.approvalModalOption?.value || values?.fileViewer?.approvalModalOption,
  };

  const transformedsortBy = values.sortBy ? values?.sortBy?.map((sort: any) => ({
    ...sort,
    mode: sort.mode?.value,
    key: sort.key?.value,
    isActive: sort?.isActive,
  })) : [];

  const transformedSearchFilterst = {
    ...values.searchFiter,
    isActive: values.searchFilter?.isActive,
    key: values.searchFilter?.key?.value,
  };

  const transformedFilters = values?.filters ? values?.filters?.map((filter: any) => {
    const { addNew, ...rest } = filter;
    return {
      ...rest,
      isActive: filter.isActive?.value,
      isMultiSelect: filter.isMultiSelect?.value,
      key: filter.key?.value,
      filters: filter.filters?.map((filter1: any) => ({
        ...filter1,
        isActive: filter1?.isActive,
        // key: filter1.key.value,
      })),
    };
  }) : [];


  const transformedTriggers = values?.triggers?.map((trigger: any) => ({
    ...trigger,
    approval: trigger?.approval?.map((appr: any) => appr?.value || appr),
    level: trigger?.level?.map((appr: any) => appr?.value || appr),
    isActive: trigger?.isActive?.value || trigger?.isActive || false,
    action: trigger?.action?.value || trigger?.action || "",
    authenticate: trigger?.authenticate || false,
    authType: trigger?.authType?.value || trigger?.authType || "",
    username: trigger?.username || "",
    password: trigger?.password || "",
    token: trigger?.token || "",
  })) || [];

  const transformedNotification = values.notification
    .filter((notification: any) => notification?.level)
    .map((notification: any) => ({
      ...notification,
      approval: notification?.approval
        ?.map((appr: any) => (typeof appr === 'object' && appr !== null) ? appr?.value : appr)
        .filter((value: any) => value !== null && value !== undefined),
      level: notification?.level
        ?.map((appr: any) => (typeof appr === 'object' && appr !== null) ? appr?.value : appr)
        .filter((value: any) => value !== null && value !== undefined),
      isActive: notification?.isActive?.value !== undefined ? notification.isActive.value : notification.isActive,
      type: notification?.type || null,
    }))
    .filter((notification: any) =>
      (notification.approval?.length || 0) > 0 ||
      (notification.level?.length || 0) > 0
    );



  const transformedTable = values?.table?.map((item: any) => {
    const { addNew, ...rest } = item;
    return {
      ...rest,
      isActive: item?.isActive?.value !== undefined ? item.isActive.value : item?.isActive,
      dateActive: item?.dateActive,
      filterActive: item?.filterActive,
      searchActive: item?.searchActive,
      header: {
        ...item?.header,
        label: item?.header?.label,
        isActive: item?.header?.isActive?.value !== undefined ? item.header.isActive.value : item?.header?.isActive,
      },
      isPaginate: {
        ...item?.isPaginate,
        paginationLimit: item?.isPaginate?.paginationLimit,
        isActive: item?.isPaginate?.isActive?.value !== undefined ? item.isPaginate.isActive.value : item?.isPaginate?.isActive,
      },
      action: {
        ...item?.action,
        view: item?.action?.view,
        edit: item?.action?.edit,
        delete: item?.action?.delete,
        downloadPDF: item?.action?.downloadPDF,
        downloadExcel: item?.action?.downloadExcel,
      },
      columnNameUpperCase: item?.columnNameUpperCase,
      columnName: item?.columnName?.map((column: any) => ({
        ...column,
        key: column?.key,
        label: column?.label,
        isActive: column?.isActive,
        isFile: column?.isFile,
        fileView: column?.fileView,
        fileDownload: column?.fileDownload,
        fieldType: column?.fieldType,
        sortActive: column?.sortActive,
        tooltipActive: column?.tooltipActive,
        tooltipLabel: column?.tooltipLabel,
        truncatedActive: column?.truncatedActive,
        labelCenter: column?.labelCenter,
        labelNoWrap: column?.labelNoWrap,
        rowType: column?.rowType?.value || column?.rowType,
      })),
      drawerTable: item?.drawerTable?.map((drawer: any) => ({
        ...drawer,
        label: drawer?.label,
        isActive: drawer?.isActive,
        labelCenter: drawer?.labelCenter,
        labelNoWrap: drawer?.labelNoWrap,
        rowType: drawer?.rowType?.value || drawer?.rowType,
      })),
    };
  }) || [];

  const transformedNewTab = values?.tab?.map((item: any) => ({
    ...item,
    isActive: item.isActive,
    url: item.url,
    label: item.label,
    icon: item.icon,
  }));

  const commonFields = {
    poExtractionType: values.poExtractionType,
    bulkApproveApproval: values.bulkApproveApproval,
    bulkRejectApproval: values.bulkRejectApproval,
    withdrawalLevel: Array.isArray(values.withdrawalLevel) ? values.withdrawalLevel?.map((it: any) => (typeof it === 'object' && it !== null) ? it?.value : it) : [],
    withdrawalApproval: Array.isArray(values.withdrawalApproval) ? values.withdrawalApproval?.map((it: any) => (typeof it === 'object' && it !== null) ? it?.value : it) : [],
    updateFirstUserNotification: values.updateFirstUserNotification,
    differentiateFirstLevel: values.differentiateFirstLevel,
    fieldsToDisable: values.fieldsToDisable?.map((item: any) => (typeof item === 'object' && item !== null) ? item?.value : item),
    forwardDocument: values.forwardDocument,
    forwardDocumentLevel: values.forwardDocumentLevel?.map((item: any) => (typeof item === 'object' && item !== null) ? item?.value : item),
    canAdditionalDocument: values.canAdditionalDocument?.map((item: any) => (typeof item === 'object' && item !== null) ? item?.value : item),
    onboarding: values.onboarding,
    isPdf: values.isPDF,
    isWord: values.isWord,
    showUploadTab: values.showUploadTab,
    dateFilter: transformedDateFilter,
    fileViewer: transformedFileViewer,
    filters: transformedFilters,
    triggers: transformedTriggers,
    sortBy: transformedsortBy,
    searchFilter: transformedSearchFilterst,
    table: transformedTable,
    tab: transformedNewTab,
    notification: transformedNotification,
    selectedUserProfile: values.selectedUserProfile,
    flowName: values.flowName,
    processName: values.processName,
    processType: values.processType,
    identifier: values.identifier,
    levels: values.levels,
    logo: values.logo,
    isLogoUrl: values.isLogoUrl,
  };

  if (values.regionApprovals) {
    return Object.keys(values.regionApprovals).map((regionKey: string) => {
      const regionApprovals = values.regionApprovals[regionKey].approvals.map((approval: any) => {
        const roleValue = (approval.role?.value || approval.role || "").toString().toLowerCase();
        
        const userObject = Array.isArray(approval.username) ? approval.username[0] : approval.username;
        const userField = userObject?.id || userObject?._id || approval.user;
        const emailField = userObject?.email || userObject?.username || (typeof userObject === 'string' ? userObject : "");

        return {
          ...approval,
          user: userField,
          isText: approval.username?.isText ? 1 : 0,
          addNew: approval.addNew ? 1 : 0,
          username: emailField,
          isActive: typeof approval.isActive === 'object' ? approval.isActive.value : approval.isActive,
          canUpload: typeof approval?.canUpload === 'object' ? approval?.canUpload?.value : (approval?.canUpload || false),
          role: roleValue,
          level: (approval.level?.value || approval.level),
          userPermission: approval.userPermission || [],
        };
      }).filter((approval: any) => isValidEmail(approval.username));

      const userName = values.selectedUserProfile?.email || "";
      const userPrefix = userName?.split('@')[0] || "";
      const profileId = values.selectedUserProfile?.profileId || "";
      const regionalWorkFlowName = [userPrefix, profileId, regionKey].filter(Boolean).join("-");

      return {
        ...commonFields,
        regions: regionKey,
        workFlowName: regionalWorkFlowName,
        approvals: regionApprovals
      };
    });
  }

  const transformedApprovals = values.approvals.map((approval: any) => {
    const roleValue = (approval.role?.value || approval.role || "").toString().toLowerCase();
    const userObject = Array.isArray(approval.username) ? approval.username[0] : approval.username;
    const userField = userObject?.id || userObject?._id || approval.user;
    const emailField = userObject?.email || userObject?.username || (typeof userObject === 'string' ? userObject : "");
    
    return {
      ...approval,
      user: userField,
      isText: approval.username?.isText ? 1 : 0,
      addNew: approval.addNew ? 1 : 0,
      username: emailField,
      isActive: typeof approval.isActive === 'object' ? approval.isActive.value : approval.isActive,
      canUpload: typeof approval?.canUpload === 'object' ? approval?.canUpload?.value : (approval?.canUpload || false),
      role: roleValue,
      level: (approval.level?.value || approval.level),
      userPermission: approval.userPermission || [],
    };
  }).filter((approval: any) => isValidEmail(approval.username));

  const regionStr = Array.isArray(values.regions) 
    ? (values.regions[0]?.value || values.regions[0]) 
    : (values.regions?.value || values.regions);

  return {
    ...commonFields,
    regions: regionStr,
    approvals: transformedApprovals,
    workFlowName: values.workFlowName,
  };
};

export const generateEditInitialValues = (data: any, fieldsArray: any = []) => {
  const toObj = (val: any, defaultVal: any) => {
    if (!val) return defaultVal;
    if (typeof val === 'object' && val.label && val.value) return val;
    if (typeof val === 'string') return { label: val, value: val };
    const label = val.label || val.regionName || val.name || val.userName || val.email || val.value || String(val);
    const value = val.value || label;
    return { label, value };
  };

  const getLevelNumber = (levelValue: any) => {
    if (!levelValue) return 999;
    const val = typeof levelValue === 'object' ? levelValue.value : levelValue;
    if (val === 'admin') return 1000; // Place admin at the end
    const match = val.match(/level[-_](\d+)/i);
    return match ? parseInt(match[1], 10) : 999;
  };

  data.poExtractionType = data.poExtractionType
  data.reset_to_level_1 = data.reset_to_level_1 || false
  
  data.processType = toObj(data.processType, { label: "nonPo", value: 'nonPo' });
  data.processName = toObj(data.processName, { label: "Domestic", value: 'domestic' });

  // Use a very direct approach for regions name matching
  let extractedProfileId = "";
  if (data.regions) {
    const raw = Array.isArray(data.regions) ? data.regions[0] : data.regions;
    const name = typeof raw === 'string' ? raw : (raw?.label || raw?.regionName || raw?.name || raw?.value);
    data.regions = name ? { label: name, value: name } : null;
    
    // Attempt to extract profileId from workFlowName even if regions exists
    if (data.workFlowName && typeof data.workFlowName === 'string') {
        const split = data.workFlowName.split("-");
        if (split.length >= 2) {
            extractedProfileId = split[1];
        }
    }
  } else if (data.workFlowName && typeof data.workFlowName === 'string') {
    // Extract region from third part of workFlowName (format: user-id-region)
    const split = data.workFlowName.split("-");
    if (split.length >= 2) {
      extractedProfileId = split[1];
    }
    if (split.length >= 3) {
      const extractedRegion = split.slice(2).join("-");
      data.regions = { label: extractedRegion, value: extractedRegion };
      // Keep workFlowName as is (full name) for the form state
    } else {
      data.regions = null;
    }
  } else {
    data.regions = null;
  }

  if (data.selectedUserProfile) {
     if (typeof data.selectedUserProfile !== 'object') {
        data.selectedUserProfile = { id: data.user, email: data.selectedUserProfile, profileId: extractedProfileId };
     } else {
        data.selectedUserProfile = {
           id: data.selectedUserProfile.id || data.user || data.selectedUserProfile._id,
           email: data.selectedUserProfile.email || data.selectedUserProfile.username || data.selectedUserProfile.emailId || "",
           profileId: data.selectedUserProfile.profileId || extractedProfileId
        };
     }
  } else if (data.user) {
     const initiatorAccount = data.approvals?.find((a: any) => 
        a.designation === "Initiator" || 
        (typeof a.designation === 'object' && (a.designation.value === "Initiator" || a.designation.label === "Initiator"))
     );
     data.selectedUserProfile = { 
        id: data.user, 
        email: initiatorAccount?.username || "",
        profileId: extractedProfileId
     };
  }

  const transformedApprovals = data.approvals?.map((approval: any) => ({
    ...approval,
    username: { id: approval.user, email: approval.username },
    selectMode: "select-async",
    password: approval.password,
    isActive:
      isActiveUser.find((item: any) => item.value === approval.isActive) ||
      isActiveUser[0],
    canUpload:
      isActiveUser.find((item: any) => item.value === approval.canUpload) ||
      isActiveUser[1],
    level:
      generateLevels(7).find((item: any) => item.value === approval.level) ||
      (approval.level === "admin" || approval.role === "admin" ? generateLevels(7)[0] : generateLevels(7)[1]),
    designation: foreignDesignations.find((d: any) => d.value === (approval.designation?.value || approval.designation)) || 
                 (typeof approval.designation === 'object' ? approval.designation : { label: approval.designation, value: approval.designation }),
    userPermission: approval.userPermission || []
  }));

  if (transformedApprovals) {
    transformedApprovals.sort((a: any, b: any) => {
      const levelA = getLevelNumber(a.level);
      const levelB = getLevelNumber(b.level);
      return levelA - levelB;
    });
  }

  data.approvals = transformedApprovals;
  // Note: regionApprovals is NOT populated during edit to keep the UI "normal" (non-tabbed)

  data.sortBy = data.sortBy?.map((sort: any) => ({
    ...sort,
    isActive: sort?.isActive,
    key:
      fieldsArray.find((item: any) => item.value === sort?.key) ||
      fieldsArray[0],
    mode: sortBy.find((item) => item.value === sort?.mode) || sortBy[1],
  }));

  data.searchFilter = {
    key:
      fieldsArray.find((item: any) => item.value === data.searchFilter?.key) ||
      fieldsArray[0],
    isActive: data.searchFilter?.isActive,
  };

  data.dateFilter = {
    filterKey:
      dateFilter.find((item) => item.value === data.dateFilter?.filterKey) ||
      dateFilter[0],
    rangeActive: data.dateFilter?.rangeActive,
    range:
      dateRanges.find((item) => item.value === data.dateFilter?.range) ||
      dateRanges[0],
    showFilter: data.dateFilter?.showFilter,
    rangePicker: data.dateFilter?.rangePicker,
  };
  // data.bulkApproveApproval = data.bulkApproveApproval;
  // data.bulkRejectApproval = data.bulkRejectApproval;
  // data.documentType = data.documentType;
  data.updateFirstUserNotification = data.updateFirstUserNotification || false;
  data.onboarding = data.onboarding || false;
  data.differentiateFirstLevel = data.differentiateFirstLevel || false;

  data.filters = data.filters?.map((filter: any) => ({
    ...filter,
    isActive:
      filterIsActive.find((items: any) => items.value === filter?.isActive) ||
      filterIsActive[0],
    isMultiSelect:
      filterIsActive.find(
        (items: any) => items.value === filter?.isMultiSelect
      ) || filterIsActive[0],
    key:
      fieldsArray.find((item: any) => item.value === filter?.key) ||
      fieldsArray[0],
    filters: filter.filters?.map((item: any) => ({
      ...item,
      isActive: item.isActive,
    })),
  }));
  data.tab = data.tab?.map((tabItem: any) => ({
    ...tabItem,
    url: tabItem?.url,
    label: tabItem?.label,
    icon: tabItem?.icon,
    isActive: tabItem?.isActive,
  }));
  data.table = data.table?.map((item: any) => ({
    ...item,
    isActive:
      tableIsActive.find((items: any) => items.value === item?.isActive) ||
      tableIsActive[0],
    dateActive: item?.dateActive,
    filterActive: item?.filterActive,
    searchActive: item?.searchActive,
    header: {
      ...item.header,
      isActive:
        tableIsActive.find(
          (items: any) => items.value === item.header?.isActive
        ) || tableIsActive[0],
      label: item.header?.label || "",
    },
    isPaginate: {
      ...item.isPaginate,
      isActive:
        tableIsActive.find(
          (items: any) => items.value === item.isPaginate?.isActive
        ) || tableIsActive[0],
      paginationLimit: item.isPaginate?.paginationLimit || 20,
    },
    action: {
      ...item.action,
      view: item.action?.view,
      edit: item.action?.edit,
      delete: item.action?.delete,
      downloadPDF: item.action?.downloadPDF,
      downloadExcel: item.action?.downloadExcel,
    },
    columnNameUpperCase: item?.columnNameUpperCase,
    columnName: item.columnName?.map((column: any) => ({
      ...column,
      key: column?.key || "",
      label: column?.label || "",
      isActive: column?.isActive || false,
      isFile: column?.isFile,
      fileView: column?.fileView,
      fieldType: column?.fieldType,
      fileDownload: column?.fileDownload,
      sortActive: column?.sortActive,
      tooltipActive: column?.tooltipActive,
      tooltipLabel: column?.tooltipLabel || "",
      truncatedActive: column.truncatedActive,
      labelCenter: column.labelCenter,
      labelNoWrap: column.labelNoWrap,
      rowNoWrap: column.rowNoWrap,
      rowType:
        rowStyle.find((items: any) => items.value === column?.rowType) ||
        rowStyle[0],
    })),
    drawerTable: item.drawerTable?.map((drawer: any) => ({
      ...drawer,
      label: drawer?.label || "",
      isActive: drawer?.isActive || false,
      labelCenter: drawer.labelCenter,
      labelNoWrap: drawer.labelNoWrap,
      rowNoWrap: drawer.rowNoWrap,
      rowType:
        rowStyle.find((items: any) => items.value === drawer?.rowType) ||
        rowStyle[0],
    })),
  }));
  return data;
};


export const updateWorkFlowInitialValues = (initialValues: any) => {
  return {
    ...initialValues,
    // table: initialValues.table.map((tableItem: any) => ({
    //   ...tableItem,
    //   columnName: fieldsArray.map((field: any) => ({
    //     ...tableItem.columnName[0],
    //     key: field.value,
    //     label: field.label,
    //     fieldType: field.type,
    //   })),
    // })),
  };
};
